import type { ButtonConfig } from '../../declare'
import { Button } from 'antd'
import { EasyModal, EasyIcon, TemplateImport, postMsg } from 'src/components'

type Props = {
  config: ButtonConfig
}
const ExcelImport = (props: Props) => {
  const { LABEL, ICON, EXCEL_TEMP_CODE } = props.config

  if (!EXCEL_TEMP_CODE) {
    return (
      <Button
        type='primary'
        icon={<EasyIcon type={ICON} defaultIcon='UploadOutlined' />}
        onClick={() => postMsg('缺少表单配置', 'info')}
      >{LABEL}</Button>
    )
  }

  return (
    <EasyModal
      fullModal
      modal={{ title: '导入Excel数据' }}
      slot={<Button type='primary' icon={<EasyIcon type={ICON} defaultIcon='UploadOutlined' />}>{LABEL}</Button>}
    >
      <TemplateImport formCode={EXCEL_TEMP_CODE} />
    </EasyModal>
  )
}

export default ExcelImport